import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  getUserStart,
  resetUser,
} from "../../../../store/features/user/user-slice";
import { useAppDispatch, useAppSelector } from "../../../../store/config";
import {
  StyledMenu,
  StyledOutletLayout,
} from "../../../../components/common/styles";
import { UserHeader } from "./components/header/UserHeader";

interface MenuItem {
  key: string;
  label: string;
  path: string;
}

export const User = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { id: userId } = useParams<{ id: string }>();
  const { user } = useAppSelector((state) => state.user);

  const menuItems: MenuItem[] = [
    {
      key: "user-details",
      label: t("User Details"),
      path: ``,
    },
    {
      key: "user-training-programs",
      label: t("Training Programs"),
      path: `training-programs`,
    },
    {
      key: "user-training-history",
      label: t("Training Programs History"),
      path: `training-programs-history`,
    },
    {
      key: "user-training-unfinished",
      label: t("Training Programs Unfinished"),
      path: `training-programs-unfinished`,
    },
  ];

  const [currentTab, setCurrentTab] = useState<string>(menuItems[0].key);

  useEffect(() => {
    userId && dispatch(getUserStart({ userId }));
    return () => {
      dispatch(resetUser());
    };
  }, [dispatch, userId]);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (currentPath) {
      const activeTab = menuItems.find(
        (item) => item.path === currentPath
      )?.key;
      activeTab ? setCurrentTab(activeTab) : setCurrentTab(menuItems[0].key);
    }
  }, [location.pathname, menuItems]);

  return (
    <>
      <UserHeader userName={user?.fullName} />

      <StyledMenu
        selectedKeys={[currentTab]}
        mode="horizontal"
        items={menuItems}
        onClick={(e) => {
          setCurrentTab(e.key);
          navigate(menuItems.find((item) => item.key === e.key)?.path || ``);
        }}
      />
      <StyledOutletLayout>
        <Outlet />
      </StyledOutletLayout>
    </>
  );
};
